"use strict";

/**
 * Get/set the values of an HTML form
 * @param {jQuery.Form} form
 */
var FormScraper = function formScraper(form) {
  if (!(this instanceof FormScraper)) {
    return new FormScraper(form);
  }
  this.form = form;
  return this;
};

/**
 * Get the values stored in a HTML form
 * @return {Object} an object with the keys as the name of the controls
 */
FormScraper.prototype.getModel = function getModel() {
  var json = this.form.serializeArray();
  var model = {};
  Object.keys(json).forEach(function (key) {
    var entry = json[key];
    var prevVal = model[entry.name];

    // If the entry exists, create a array with the values
    if (prevVal) {
      if (!(prevVal instanceof Array)) model[entry.name] = [prevVal];
      model[entry.name].push(entry.value);
    } else {
      model[entry.name] = entry.value;
    }
  });
  return model;
};

/**
 * Set HTML form with the values passed as parameter
 * @param {Object} model - tipically a result of getModel
 */
FormScraper.prototype.setModel = function setModel(model) {
  var self = this;
  Object.keys(model).forEach(function (name) {
    var values = model[name];
    var input = self.form.find("[name=".concat(name, "]"));

    // convert the single values into array for easy processing
    values = values instanceof Array ? values : [values];

    // only checkbox and radio has another treatment for setting a value
    if (input.is('[type=checkbox]') || input.is('[type=radio]')) {
      Object.keys(values).forEach(function (key) {
        input.filter("[value=".concat(values[key], "]")).attr('checked', true);
      });
    } else {
      input.val(values);
    }
  });
};
module.exports = FormScraper;
